import { Download } from 'lucide-react';
import { cn } from '@/lib/utils';
import { openInstallPrompt } from '@/lib/pwa';
import { usePwaInstall } from './usePwaInstall';

/** Opção fixa "Instalar aplicativo"; some quando não é instalável ou já está instalado */
export function InstallMenuItem({ className }: { className?: string }) {
  const { isAvailable } = usePwaInstall();
  if (!isAvailable) return null;
  return (
    <button
      type="button"
      onClick={() => openInstallPrompt('menu')}
      className={cn(
        'flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm font-medium text-ink/70 transition-colors hover:bg-ink/5 hover:text-ink',
        className
      )}
    >
      <Download className="h-[18px] w-[18px]" aria-hidden="true" />
      Instalar aplicativo
    </button>
  );
}
